/**
 * An agent's kind, as the Agents page creates it and the agent's card changes it.
 *
 * `advisor` is the kind the hourly advisor looks for (worker `lib/advisor-cycle.ts`,
 * `FROM agent WHERE kind = $1` with `advisor`); before it was offered here, an advisor could
 * not be made from the SPA at all. The kit takes any non-empty text as a kind (POST and PATCH
 * `/api/v1/agents`), so this list is what the console offers, not what the kit checks.
 */

export const AGENT_KINDS = [
	{ value: "buyer", label: "buyer" },
	{ value: "orchestrator", label: "orchestrator" },
	{ value: "analyst", label: "analyst" },
	{ value: "advisor", label: "advisor" },
];

/**
 * Shown where an advisor is made. The advisor's query counts every agent of that kind, whatever
 * its status (`advisor-cycle.ts` `advisorAgent`): two of them, even one retired, and it proposes
 * nothing, saying «more than one advisor agent».
 */
export const ADVISOR_ONLY_ONE =
	"Keep one advisor. With two or more agents of kind advisor — paused and retired ones count too — the hourly advisor proposes nothing.";

/** The list, plus the agent's own kind when it is not one of them — so the Select shows what is stored. */
export function kindOptions(current: string): { value: string; label: string }[] {
	return AGENT_KINDS.some((k) => k.value === current) || !current
		? AGENT_KINDS
		: [...AGENT_KINDS, { value: current, label: current }];
}

/** The body of `POST /api/v1/agents` from the Agents form. */
export function createAgentBody(name: string, kind: string): { name: string; kind: string } {
	return { name: name.trim(), kind };
}

/** The body of `PATCH /api/v1/agents/:id` when the card changes the kind — the kind alone. */
export function kindChangeBody(kind: string): { kind: string } {
	return { kind };
}
